import React, { Component } from 'react'
import Actions from './common/Actions'

export default class Crop extends Component {
  render() {
    return (
      <div className="crop">
        <Actions
          showApplyButton
          onApplyClicked={this.props.onApplyClicked}
          undoDisabled={this.props.undoDisabled}
          redoDisabled={this.props.redoDisabled}
          onUndoClicked={this.props.onUndoClicked}
          onRedoClicked={this.props.onRedoClicked}
        />
        <div id="crop-controls"/>
      </div>
    )
  }
}
